<template slot-scope="scope">
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">销售计划签约变更单</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button @click="$router.go(-1)">返回</form-button>
        <form-button name="保存" @click="saveData('SAVE')"/>
        <!-- <form-button name="修改" @click="handleClick(false)" v-if="isEnter && isEdit"/> -->
        <!-- <form-button name="显示" @click="handleClick(true)" v-if="isShow && !isEdit"/> -->
        <form-button name="提交" @click="saveData('SUBMIT')" />
        <!-- <form-button name="审核提交" @click="saveData('APPROVE')" v-if="isApprove"/> -->
        <!-- <form-button name="审核通过" @click="saveData('APPROVE')" v-if="!isEdit && (isPass || isApprove)"/>
        <form-button name="提交OA" @click="showOaDialog=true" v-if="!isEdit && isOa"/>
        <form-button name="退回" @click="saveData('CANCEL')" v-if="!isEdit && (isSubmit || isApprove || isBack)"/> -->
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        :show-message="false"
        label-width="100px"
        :model="conditions"
        :rules="rules"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="单据编号">
              <el-input :value="conditions.plan_cntr_no" disabled />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-select :value="conditions.order_type" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0072']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划年度">
              <el-input :value="conditions.gjahr" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isChangeList">
          <!-- <el-col :lg="8" :md="12"> -->
            <!-- <el-form-item prop="chg_plan_cntr_no" class="line-16" label="销售计划申请编号"> -->
            <el-form-item prop="chg_plan_cntr_no" class="line-16" label="销售计划申请编号" :disabled="isChangeListDetail">
              <wly-input
                v-model="conditions.chg_plan_cntr_no"
                input-type="qySalePlan"
                @enter="handleInter"
                @handleSuffixClick="openSelectDialog($event, '销售计划选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer" label="客户编号">
              <wly-input
                :disabled="isListDetail"
                @enter="handleEnter"
                @handleSuffixClick="openDialog($event, '客户选择')"
                v-model="conditions.customer"
                input-type="customer"
                :query-params="{mode: 'SPCT'}"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input :value="conditions.cust_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select :value="conditions.customer_type" disabled clearable>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型">
              <el-select v-model="conditions.plan_type" clearable @change='changeVal' :disabled="isListDetail">
                <el-option
                  v-for="item in planTypeList"
                  :key="item.newPlanType"
                  :label="item.newPlanTypeName"
                  :value="item.newPlanType"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-select v-model="conditions.chfl" clearable filterable @change='changeVal' :disabled="isListDetail">
                <el-option
                  v-for="item in chflList"
                  :key="item.chfl"
                  :label="item.chflName"
                  :value="item.chfl"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isChangeList">
            <el-form-item label="变更类型">
              <el-select v-model="conditions.adj_reason" disabled clearable >
                <el-option
                  v-for="item in selectDataOptions['A0003']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="sal_center">
              <!-- :disabled="isEdit" -->
              <el-select
                v-model="conditions.sal_center"
                placeholder=""
                @change="saleCenterChange"
                disabled
              >
                <el-option
                  v-for="item in saleCenterLists"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="大区副总审核" prop="zassign">
              <el-select
                v-model="conditions.zassign"
                @change="zassignChange($event)"
                placeholder=""
                :disabled="role.ROLE !== 'WLY025'"
              >
                <el-option
                  v-for="item in zassignLists"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"

                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="conditions.zassign">
            <el-form-item label="大区副总" prop="assign">
              <el-select
                v-model="assignLists"
                @change="assignBpChange($event)"
                placeholder=""
                multiple
              >
                <el-option
                  v-for="item in deputyLists"
                  :key="item.partner"
                  :label="item.name"
                  :value="item.partner"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="建议签约量">
              <el-input :value="conditions.pre_aloc_plan_qty" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="建议签约下限">
              <el-input :value="conditions.pre_aloc_min_qty" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="建议签约上限">
              <el-input :value="conditions.pre_aloc_max_qty" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="签约说明" prop="signing_note">
              <el-input
                :disabled="isQyDetail"
                v-model="conditions.signing_note"
                type="textarea"
                rows="4"
                maxlength="2000"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.ZZFLD00000"
                :disabled="conditions.status !== 'E0003'"
                rows="4"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col> -->
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input :value="conditions.uname_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建时间">
              <el-input :value="conditions.datum" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select :value="conditions.status" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0071']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <TableCommon v-if="!isChangeList" :title="countYearArea" :custome-config="() => vxeShowCustom('gridOptionArea')">
        <vxe-grid
          ref="gridOptionArea"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionArea.columns"
          :data="gridOptionArea.data"
        >
        </vxe-grid>
      </TableCommon>

      <TableCommon v-if="!isChangeList" :title="countYearChannel" :show-custome="false">
        <el-checkbox-group>
          <el-row>
            <el-col v-for="item in channelList" :key="item.channel" :lg="6" :md="8">
              <el-checkbox :label="item.channel" disabled>{{ item.chlName }}</el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </TableCommon>
      <!-- <TableCommon title="历史数据" :custome-config="() => vxeShowCustom('xTable2')">
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsPlanDetail.columns"
          :data="gridOptionsPlanDetail.data"
          :span-method="mergeRowMethod"
        >
          <template v-for="item in gridOptionsPlanDetail.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon> -->
      <!-- <TableCommon :title="countYearPlan" :showCustome="showCustome" :custome-config="() => vxeShowCustom('orderDetail')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          style="background:red"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="300"
          align="center"
          size="medium"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field" >
              <el-input
                disabled
                v-model="row[item.field]"
                size="mini"
                type="number"
                @keyup.enter.native="saveSaleItem(item.field, row[item.field])"
              />
            </div>
          </template>
        </vxe-grid>
      </TableCommon> -->
      <TableCommon :title="countYearPlan+'调整明细'" :showCustome="showCustome" :custome-config="() => vxeShowCustom('orderDetail')">
        <vxe-grid
          ref="TTable"
          class="table-block"
          style="background:red"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="390"
          align="center"
          size="medium"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridTrimOptions.columns"
          :data="gridTrimOptions.data"
          :row-style="rowStyle"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridTrimOptions.columns" #[item.field]="{ row }">
            <div :key="item.field" >
              <el-input
                v-if=" gridTrimOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                :disabled="!row.dis"
                size="mini"
                oninput="value=value.replace(/[^\-?\d]/g, '')"
                @keyup.enter.native="saveSaleItem(item.field, row)"
              />
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <!-- <template #toolbar /> -->
          <template #filename="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

    </div>
    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="销售计划选择"
      :visible.sync="showPlanDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showPlanDialog">
        <SalePlanNewList ref="dialogEdit" sourceType='detail' />
      </template>
      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showPlanDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitPlanHandle">提交</el-button>
      </div>
    </el-dialog>
    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="客户选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <ClientSelect ref="dialogSelect" mode="SPCT"/>
      </template>

      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showDialog = false">取消</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>
    <!-- 提交OA -->
    <el-dialog
      v-dialogDrag
      title="提交OA审批"
      :visible.sync="showOaDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showOaDialog">
        <div>
          <el-form ref="form" :model="dialogForm" label-width="90px">
            <el-form-item label="正文">
              <el-input type="textarea" rows="3" resize="none" v-model="dialogForm.main_contont" disabled></el-input>
            </el-form-item>
            <el-form-item label="大区意见">
              <el-input type="textarea" rows="3" resize="none" v-model="dialogForm.audit_comment"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showOaDialog = false">取消</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="getSendOAFiles">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findchflList, findnewPlanTypeList, findSaleplanHistory, findContractArea, findContractChannel, findBrandPrice, getSendOAFiles} from '@/api/signing'
import {spctChgOrder, getSpctById, getCenterFz} from '@/api/sap/signing-sap'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import { sapDownloadFile } from '@/utils/frontExport'
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
const SalePlan = () => import('@/components/dialog/SalePlan.vue')
import SalePlanNewList from './salePlanNewList.vue'
import { Message } from 'element-ui'
import { formatWlyYear } from '@/utils/handleFormData'
export default {
  components: {
    ClientSelect,
    SalePlanNewList
  },
  data() {
      return {
        checkAssign: [],
        zassignLists: [
          {
            key: 'X',
            value: '是'
          },
          {
            key: '',
            value: '否'
          }
        ],
        disCheckList: [],
        deputyLists: [],
        assignLists: [],
        showCustome: false,
        dialogForm: {
          main_contont: '',
          audit_comment: '',
        },
        totalRecomQy: 0,
        totalRecomPrice: 0,
        totalRealityQy: 0,
        totalRealityPrice: 0,
        showOaDialog: false,
        saveGridOptions: [],
        showPlanDialog: false,
        isEdit: true,
        mode: '',
        saleCenterLists: [],
        chflList: [],
        planTypeList: [],
        countYearArea: '',
        countYearChannel: '',
        countYearPlan: '',
        showDialog: false,
        selectDataOptions: {},
        rules: {
          chg_plan_cntr_no: [{ required: true, message: '请填写销售计划申请编号', trigger: 'change' }],
          signing_note: [{ required: true, message: '请填写签约说明', trigger: 'change' }],
        },
        loading: false,
        errorList: [],
        orderTypeList:[
          {
            value:'ZP01',
            name: '新增单'
          },
          {
            value:'ZP02',
            name: '变更单'
          },
        ],
        conditions: {
          chg_plan_cntr_no: '',
          customer: '',
          cust_name: '',
          customer_type: '',
          sal_center: '',
          saleCenterTextView: '',
          brandTextView: '',
          planTypeTextView: '',
          gjahr: 2024,
          order_type: 'ZP02',
          cntrname: '',
          status: 'E001', // 状态
          ZZFLD000001Name: '',
          ZZFLD00003E: '',
          datum: '',
          uname_text: '',
          adj_reason:'V013',
          pre_aloc_plan_qty: '',
          pre_aloc_min_qty: '',
          pre_aloc_max_qty: ''
        },
        gridOptionsPlanDetail: {
          columns: [
            { type: 'seq', field: 'seq', title: '序号', width: 50 },
            {
              field: 'planQty21',
              title: '2021年计划量',
            },
            {
              field: 'billQty21',
              title: '2021年开票数量',
            },
            {
              field: 'planQty22',
              title: '2022年计划量',
            },
            {
              field: 'billQty22',
              title: '2022年开票数量',
            },
            {
              field: 'planQty23',
              title: '2023年计划量',
            },
            {
              field: 'billQty23',
              title: '2023年开票数量',
            },
            {
              field: 'deliverQty21',
              title: '2021年发货数量',
            },
            {
              field: 'deliverQty22',
              title: '2022年发货数量',
            },
            {
              field: 'deliverQty23',
              title: '2023年发货数量',
            },
            {
              field: 'breakRuleQty',
              title: '2023年违规数量',
            },
            {
              field: 'omitQty',
              title: '遗留扣减量',
            },
            {
              field: 'selledStock',
              title: '动销库存',
            },
            {
              field: 'selledQty21',
              title: '2021年动销量',
            },
            {
              field: 'selledQty22',
              title: '2022年动销量',
            },
            {
              field: 'selledQty23',
              title: '2023年动销量',
            },
            {
              field: 'signedQty',
              title: '建议签约量',
            },
          ],
          data: []
        },
        gridOptionsFile: {
          columns: [
            { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
            {
              field: 'filename',
              title: '附件名称',
              slots: { default: 'filename' }
            },
            { field: 'mimetype', title: '附件类型' },
            {
              field: 'filelength',
              title: '大小',
              formatter: ({ cellValue }) => formatSapFileSize(cellValue)
            },
            {
              field: 'created_date',
              title: '上传日期',
              formatter: ({ cellValue }) => formatSapDate(cellValue)
            },
            {
              field: 'created_time',
              title: '上传时间',
              formatter: ({ cellValue }) => formatSapTime(cellValue)
            }
          ],
          data: [],
          delData: []
        },
        gridOptionArea: {
          columns: [
            { type: 'seq', field: 'seq', title: '序号', width: 50 },
            { field: 'regn_name', title: '经营区域/省份/直销市',},
            { field: 'city_name', title: '经营区域/城市/地区',},
            { field: 'street_name', title: '经营区域/区县',}
          ],
          data: []
        },
        gridOptions: {
          columns: [
            {
              field: 'oper_name',
              title: '分配人',
              width: 120,
            },
            {
              field: 'aloc_total_qty',
              title: '可分配总量',
              width: 120,
              slots: { default: 'aloc_total_qty' }
            },
            {
              field: 'plan_qty_12',
              title: '12月份',
              slots: { default: 'plan_qty_12' }
            },
            {
              field: 'plan_qty_1',
              title: '1月份',
              slots: { default: 'plan_qty_1' }
            },
            {
              field: 'plan_qty_2',
              title: '2月份',
              slots: { default: 'plan_qty_2' }
            },
            {
              field: 'plan_qty_3',
              title: '3月份',
              slots: { default: 'plan_qty_3' }
            },
            {
              field: 'plan_qty_4',
              title: '4月份',
              slots: { default: 'plan_qty_4' }
            },
            {
              field: 'plan_qty_5',
              title: '5月份',
              slots: { default: 'plan_qty_5' }
            },
            {
              field: 'plan_qty_6',
              title: '6月份',
              slots: { default: 'plan_qty_6' }
            },
            {
              field: 'plan_qty_7',
              title: '7月份',
              slots: { default: 'plan_qty_7' }
            },
            {
              field: 'plan_qty_8',
              title: '8月份',
              slots: { default: 'plan_qty_8' }
            },
            {
              field: 'plan_qty_9',
              title: '9月份',
              slots: { default: 'plan_qty_9' }
            },
            {
              field: 'plan_qty_10',
              title: '10月份',
              slots: { default: 'plan_qty_10' }
            },
            {
              field: 'plan_qty_11',
              title: '11月份',
              slots: { default: 'plan_qty_11' }
            },
            {
              field: 'price',
              title: '单价',
              slots: { }
            },
            {
              field: 'total_price',
              title: '总金额(万元)',
            },
          ],
          data: [
            {
              plan_qty_1: '',
              plan_qty_2: '',
              plan_qty_3: '',
              plan_qty_4: '',
              plan_qty_5: '',
              plan_qty_6: '',
              plan_qty_7: '',
              plan_qty_8: '',
              plan_qty_9: '',
              plan_qty_10: '',
              plan_qty_11: '',
              plan_qty_12: '',
              price:'',
              total_price: ''
            }
          ],
          columnsFieldTypes: {
            aloc_total_qty: 'input',
            plan_qty_1: 'input',
            plan_qty_2: 'input',
            plan_qty_3: 'input',
            plan_qty_4: 'input',
            plan_qty_5: 'input',
            plan_qty_6: 'input',
            plan_qty_7: 'input',
            plan_qty_8: 'input',
            plan_qty_9: 'input',
            plan_qty_10: 'input',
            plan_qty_11: 'input',
            plan_qty_12: 'input',
          }
        },
        gridTrimOptions: {
          columns: [
            {
              field: 'oper_name',
              title: '分配人',
              width: 120,
            },
            {
              field: 'qty_type_text',
              title: '类型',
              width: 110,
            },
            {
              field: 'total',
              title: '申请计划量',
              width: 60,
              slots: { default: 'total' }
            },
            {
              field: 'plan_qty_12',
              title: '12月份',
              slots: { default: 'plan_qty_12' }
            },
            {
              field: 'plan_qty_1',
              title: '1月份',
              slots: { default: 'plan_qty_1' }
            },
            {
              field: 'plan_qty_2',
              title: '2月份',
              slots: { default: 'plan_qty_2' }
            },
            {
              field: 'plan_qty_3',
              title: '3月份',
              slots: { default: 'plan_qty_3' }
            },
            {
              field: 'plan_qty_4',
              title: '4月份',
              slots: { default: 'plan_qty_4' }
            },
            {
              field: 'plan_qty_5',
              title: '5月份',
              slots: { default: 'plan_qty_5' }
            },
            {
              field: 'plan_qty_6',
              title: '6月份',
              slots: { default: 'plan_qty_6' }
            },
            {
              field: 'plan_qty_7',
              title: '7月份',
              slots: { default: 'plan_qty_7' }
            },
            {
              field: 'plan_qty_8',
              title: '8月份',
              slots: { default: 'plan_qty_8' }
            },
            {
              field: 'plan_qty_9',
              title: '9月份',
              slots: { default: 'plan_qty_9' }
            },
            {
              field: 'plan_qty_10',
              title: '10月份',
              slots: { default: 'plan_qty_10' }
            },
            {
              field: 'plan_qty_11',
              title: '11月份',
              slots: { default: 'plan_qty_11' }
            },
            {
              field: 'aloc_total_qty',
              title: '月度计划量合计',
              width: 60,
              slots: { default: 'aloc_total_qty' }
            },
            {
              field: 'price',
              title: '单价',
              width: 60,
            },
            {
              field: 'total_price',
              title: '总金额(万元)',
              width: 70,
            },
          ],
          data: [
            {
              total: '',
              plan_qty_1: '',
              plan_qty_2: '',
              plan_qty_3: '',
              plan_qty_4: '',
              plan_qty_5: '',
              plan_qty_6: '',
              plan_qty_7: '',
              plan_qty_8: '',
              plan_qty_9: '',
              plan_qty_10: '',
              plan_qty_11: '',
              plan_qty_12: '',
              price:'',
              total_price: ''
            }
          ],
          columnsFieldTypes: {
            total: 'input',
            aloc_total_qty: 'input',
            plan_qty_1: 'input',
            plan_qty_2: 'input',
            plan_qty_3: 'input',
            plan_qty_4: 'input',
            plan_qty_5: 'input',
            plan_qty_6: 'input',
            plan_qty_7: 'input',
            plan_qty_8: 'input',
            plan_qty_9: 'input',
            plan_qty_10: 'input',
            plan_qty_11: 'input',
            plan_qty_12: 'input',
          }
        },
        gridRecordOptions: {
          data: [],
          columns: [
            { field: 'operationer', title: '操作员' },
            { field: 'oper_name', title: '操作员姓名' },
            { field: 'status_text', title: '操作状态' },
            { field: 'audit_comment', title: '审核意见'},
            { field: 'changin_date', title: '变更日期',formatter: ({ cellValue }) => formatSapDate(cellValue) },
            { field: 'changin_time', title: '变更时间',formatter: ({ cellValue }) => formatSapTime(cellValue)  }
          ]
        },
        gridSysOptions:{
          data: [],
          columns: [
            { field: 'operationer', title: '操作员' },
            { field: 'oper_name', title: '操作员姓名' },
            { field: 'main_contont', title: '正文' },
            { field: 'audit_comment', title: '大区意见'},
            { field: 'file_addr', title: '附件地址' },
            { field: 'changin_date', title: '创建日期',formatter: ({ cellValue }) => formatSapDate(cellValue) },
            { field: 'changin_time', title: '创建时间' ,formatter: ({ cellValue }) => formatSapTime(cellValue) }
          ]
        },
        validRules: {},
        chanelCheckList: [],
        channelList: [],
        templates: {
          plan_qty_1: '',
          plan_qty_2: '',
          plan_qty_3: '',
          plan_qty_4: '',
          plan_qty_5: '',
          plan_qty_6: '',
          plan_qty_7: '',
          plan_qty_8: '',
          plan_qty_9: '',
          plan_qty_10: '',
          plan_qty_11: '',
          plan_qty_12: '',
          price: '',
          total_price: '',
          aloc_total_qty: '',
          dis: '1'
        },
        bgjhl: [],
      }
  },
  computed: {
    // 进入页面显示哪些按钮
    isEnter(){
      const arr1 = ['WLY013','WLYALL']
      const arr2 = ['E001','E002','E003', 'E004','E005']
      if(arr1.indexOf(this.role.ROLE) > -1 && arr2.indexOf(this.conditions.status) > -1){
        return true
      }
      const arr3 = ['E001','E002','E003']
      if(arr3.indexOf(this.conditions.status) > -1 && this.role.ROLE === 'WLY014'){
        return true
      }
      const arr4 = ['WLY002','WLYALL']
      if(this.conditions.status === 'E007' && arr4.indexOf(this.role.ROLE) > -1){
        return true
      }
      return false
    },
    // 显示‘提交’和‘退回’按钮；
    isSubmit(){
      const arr = ['WLY013','WLY014','WLYALL']
      if(arr.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E002'){
          return true
        }
        return false
    },
    // 审批通过+退回
    isApprove(){
      const arr1 = ['WLY013','WLYALL']
      const arr2 = ['E003', 'E004','E008']
      if(arr1.indexOf(this.role.ROLE) > -1 && arr2.indexOf(this.conditions.status) > -1){
        return true
      }
      return false
    },
    // 单独退回
    isBack(){
      if(this.conditions.status === 'E003' && this.role.ROLE === 'WLY014'){
        return true
      }
      return false
    },
    // 提交OA
    isOa(){
      const arr1 = ['WLY013','WLYALL']
      if(arr1.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E005'){
        return true
      }
      return false
    },
    // 审核通过
    isPass(){
      // const arr1 = ['WLY013','WLYALL']
      const arr2 = ['WLY002','WLYALL']
      // if(arr1.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E008'){
      //   return true
      // }
      if(arr2.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E007'){
        return true
      }
      return false
    },
    // 显示按钮
    isShow(){
      const arr = ['WLY013','WLY014','WLYALL']
        if(arr.indexOf(this.role.ROLE) > -1 ){
          return true
        }
        return false
    },
    // 是否是变更单
    isChangeList(){
      return true
    },
    // 草稿
    isDraft(){
      const arr = ['WLY013','WLY014','WLYALL']
      if(arr.indexOf(this.role.ROLE) > -1 && this.conditions.status === 'E002'){
        return true
      }
      return false
    },
    // 填写签约
    isQyDetail(){
      return false
    },
    // 新增单修改
    isListDetail(){
      if(!this.isEdit && this.isDraft && !this.isChangeList){
       return false
      }
      return true
    },
    // 变更单修改
    isChangeListDetail(){
      return false
    },
    //计划明细
    isPlanList(){
      if(!this.isEdit && this.isDraft && this.isChangeList){
       return false
      }
      if(!this.isEdit && this.isDraft && !this.isChangeList){
       return false
      }
      return true
    },
    ...mapGetters(['customerInfo', 'role'])
  },

  watch:{

  },
  created() {
    this.conditions.gjahr = formatWlyYear()
    const {plan_cntr_no} = this.$route.query
    if(plan_cntr_no){
      this.getSpctById(plan_cntr_no)
    }
    this.getSelectDictDataOrigin('A0003')
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0071')
    this.getSelectDictDataOrigin('A0072')
    this.getSelectDictDataOrigin('A0043')
    this.getSelectDictDataOrigin('orgList')
    // this.getContractQd()
    this.conditions.uname_text = this.role.login_user
    this.conditions.datum = this.$utilsCommon.parseTime(
      new Date().getTime(),
      '{y}-{m}-{d}'
    )
    this.countYearArea = this.conditions.gjahr + '年营销区域'
    this.countYearChannel = this.conditions.gjahr +'年营销渠道'
    this.countYearPlan = this.conditions.gjahr +'年计划量'
  },
  methods: {
    assignBpChange(list){
      this.checkAssign = []
      this.conditions.assign = []
      list.forEach(ele => {
        this.deputyLists.forEach(item => {
          if(ele === item.partner){
            this.conditions.assign.push(item)
            this.checkAssign.push(item)
          }
        });
      });
    },
    async getCenterFz(data){
      const params = {
        user_bp: this.role.USER_BP,
        sal_center: [
        {
          high: "",
          low: data.sal_center,
          option: "EQ",
          sign: "I",
        }
        ],
      }
      const res = await getCenterFz(params)
      this.deputy = res.data.length > 0
      this.deputyLists = res.data
    },
    zassignChange(e){
      // e && this.getCenterFz(this.conditions)
      this.conditions.assign = []
      this.assignLists = []
    },
    rowStyle({ row, rowIndex }) {
      console.log(`output->`,rowIndex)
      if (!row.dis) {
        return {
          backgroundColor: '#f2f8fe',
        }
      }
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod ({ row, _rowIndex, column, visibleData }) {
      // fields是哪些需要合并的单元格
      const fields1= [
        'breakRuleQty',
        'omitQty',
        'selledStock',
        'selledQty21',
        'selledQty22',
        'selledQty23',
      ]
      if (row[column.property] && fields1.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        // 当满足以下条件才去合并上面的单元格
        if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['brandTextView'] === row['brandTextView'] && prevRow['saleCenterTextView'] === row['saleCenterTextView']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['brandTextView'] === row['brandTextView'] && nextRow['saleCenterTextView'] === row['saleCenterTextView']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }else if (row[column.property] && column.property === 'signedQty') {
        // const prevRow = visibleData[_rowIndex - 1]
        // let nextRow = visibleData[_rowIndex + 1]
        // // 当满足以下条件才去合并上面的单元格
        // if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && prevRow['brandTextView'] === row['brandTextView']) {
        //   return { rowspan: 0, colspan: 0 }
        // } else {
        //   let countRowspan = 1
        //   while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && nextRow['brandTextView'] === row['brandTextView']) {
        //     nextRow = visibleData[++countRowspan + _rowIndex]
        //   }
        //   if (countRowspan > 1) {
        //     return { rowspan: countRowspan, colspan: 1 }
        //   }
        // }
      }
    },
    handleClick(flag){
      this.isEdit = flag
      // 处理新增一行明细
      if(this.gridOptions.data.length === this.saveGridOptions.length && this.isApprove){
        let res = {
          plan_qty_1: '',
          plan_qty_2: '',
          plan_qty_3: '',
          plan_qty_4: '',
          plan_qty_5: '',
          plan_qty_6: '',
          plan_qty_7: '',
          plan_qty_8: '',
          plan_qty_9: '',
          plan_qty_10: '',
          plan_qty_11: '',
          plan_qty_12: '',
          price:'',
          total_price: '',
          dis: '1'
        }
        const arr = [1,2,3,4,5,6,7,8,9,10,11,12]
        this.gridOptions.data.forEach(ele => {
          arr.forEach(item => {
            res['plan_qty_'+item] = ele['plan_qty_'+item]
            res.total_price = ele.total_price
            res.aloc_total_qty = ele.aloc_total_qty
            res.total = ele.total
          });
        });
        this.gridOptions.data.push(res)
        // this.findBrandPrice()
      }
      if(flag && this.gridOptions.data.length !== this.saveGridOptions.length){
        this.gridOptions.data.pop()
      }
    },
    // 打开窗口
    openSelectDialog(e) {
      e.target.blur()
      this.showPlanDialog = true
    },
    handleTemp(){
      // if(this.role.ROLE === 'WLY014'){
      //   this.templates.qty_type = 'V005'
      //   this.templates.qty_type_text = '渠道经理调整量'
      // }else if(this.role.ROLE === 'WLY013'){
      //   if(this.conditions.sal_center === this.role.deptCode){
      //     this.templates.qty_type = 'V007'
      //     this.templates.qty_type_text = '大区总经理调整量'
      //   }else{
      //     this.templates.qty_type = 'V006'
      //     this.templates.qty_type_text = '区域总经理调整量'
      //   }
      // }else if(this.role.ROLE === 'WLYALL'){
      //   if(this.conditions.status === 'E001' || this.conditions.status === 'E002'){
      //     this.templates.qty_type = 'V005'
      //     this.templates.qty_type_text = '渠道经理调整量'
      //   }else if(this.conditions.status === 'E003'){
      //     this.templates.qty_type = 'V006'
      //     this.templates.qty_type_text = '区域总经理调整量'
      //   }else if(this.conditions.status === 'E004' || this.conditions.status === 'E008'){
      //     this.templates.qty_type = 'V007'
      //     this.templates.qty_type_text = '大区总经理调整量'
      //   }
      // }
      this.templates.qty_type_text = '本次调整量'
      this.gridTrimOptions.data.push(this.templates)
    },
    // 销售计划弹窗内的方法这边来处理，方便数据回调在本页面处理
    async submitPlanHandle() {
      const data = await this.$refs.dialogEdit.submitCheckedForm()
      if (data.plan_cntr_no) {
        const params = {
          user_bp: this.role.USER_BP,
          plan_cntr_no: data.plan_cntr_no,
          dept_code: this.role.deptCode,
          mode: 'PD'
        }
        const res = await getSpctById(params)
        if(res.msgtype === "E"){
          return Message.warning(res.message)
        }
        this.gridOptionsFile.data = [...res.data.attachment]
        this.conditions.customer = res.data.head.customer
        this.conditions.cust_name = res.data.head.cust_name
        this.conditions.customer_type = res.data?.head?.customer_type
        this.conditions.chg_plan_cntr_no =  res.data?.head?.plan_cntr_no
        this.conditions.chfl = res.data?.head?.chfl
        this.conditions.pre_aloc_plan_qty = res.data?.head?.pre_aloc_plan_qty
        this.conditions.pre_aloc_min_qty = res.data?.head?.pre_aloc_min_qty || res.data?.head?.signedDown
        this.conditions.pre_aloc_max_qty = res.data?.head?.pre_aloc_max_qty || res.data?.head?.signedUp
        // this.conditions.uname_text = res.data?.head?.uname_text
        this.conditions.plan_type = res.data?.head?.plan_type
        this.saleCenterLists =[{
          zzfld00001h: res.data?.head?.sal_center,
          mc_short: res.data?.head?.sal_center_text,
      }]
        this.conditions.sal_center = res.data?.head?.sal_center
        this.getCenterFz(this.conditions)
        this.gridRecordOptions.data = res.data?.history || []
        this.gridOptionsPlanDetail.data = []
        res.data.lssl.length > 0 && res.data.lssl.forEach(ele => {
          this.gridOptionsPlanDetail.data.push({
            planQty21: ele.plan_qty_21,
            planQty22: ele.plan_qty_22,
            planQty23: ele.plan_qty_23,
            billQty21: ele.bill_qty_21,
            billQty22: ele.bill_qty_22,
            billQty23: ele.bill_qty_23,
            deliverQty21: ele.deliver_qty_21,
            deliverQty22: ele.deliver_qty_22,
            deliverQty23: ele.deliver_qty_23,
            selledStock: ele.selled_stock,
            selledQty21: ele.selled_qty_21,
            selledQty22: ele.selled_qty_22,
            selledQty23: ele.selled_qty_23,
            omitQty: this.conditions.legacy_deduction,
            breakRuleQty: this.conditions.viola_qty,
          })
        });
        this.bgjhl = Object.assign([], res.data.bgjhl)
        this.gridTrimOptions.data = res.data.bgjhl || []
        this.gridTrimOptions.data.forEach((ele,index) => {
          ele.total = ele.aloc_total_qty
          for (const key in ele) {
            if (Object.hasOwnProperty.call(ele, key)) {
              if(ele[key] && ele[key].indexOf('-')>-1){
                this.gridTrimOptions.data[index][key] = '-' + ele[key].replace('-', '')
              }
            }
          }
        });
        this.templates.price = res.data?.bgjhl[0]?.price || ''
        // this.gridTrimOptions.data.push(this.templates)
        this.handleTemp()
      }
      this.showPlanDialog = false
    },
    // 申请编号 控件回车
    async handleInter(e, type, res) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (res.msgtype === 'E') return
      this.gridOptionsFile.data = [...res.data.attachment]
      this.conditions.customer = res.data.head.customer
      this.findchflList()
      this.findnewPlanTypeList()
      this.conditions.cust_name = res.data.head.cust_name
      this.conditions.customer_type = res.data?.head?.customer_type
      this.conditions.pre_aloc_plan_qty = res.data?.head?.pre_aloc_plan_qty
      this.conditions.pre_aloc_min_qty = res.data?.head?.pre_aloc_min_qty || res.data?.head?.signedDown
      this.conditions.pre_aloc_max_qty = res.data?.head?.pre_aloc_max_qty || res.data?.head?.signedUp
      this.conditions.chfl = res.data?.head?.chfl
      this.conditions.datum = res.data?.head?.datum
      // this.conditions.uname_text = res.data?.head?.uname_text
      this.conditions.plan_type = res.data?.head?.plan_type
      this.saleCenterLists =[{
          zzfld00001h: res.data?.head?.sal_center,
          mc_short: res.data?.head?.sal_center_text,
      }]
      this.conditions.sal_center = res.data?.head?.sal_center
      this.gridRecordOptions.data = res.data?.history || []
      this.getCenterFz(this.conditions)
      // this.gridTrimOptions.data[0].price = res.data?.item_chg?.price || ''
      this.gridOptionsPlanDetail.data = []
      res.data.lssl.length > 0 && res.data.lssl.forEach(ele => {
        this.gridOptionsPlanDetail.data.push({
          planQty21: ele.plan_qty_21,
          planQty22: ele.plan_qty_22,
          planQty23: ele.plan_qty_23,
          billQty21: ele.bill_qty_21,
          billQty22: ele.bill_qty_22,
          billQty23: ele.bill_qty_23,
          deliverQty21: ele.deliver_qty_21,
          deliverQty22: ele.deliver_qty_22,
          deliverQty23: ele.deliver_qty_23,
          selledStock: ele.selled_stock,
          selledQty21: ele.selled_qty_21,
          selledQty22: ele.selled_qty_22,
          selledQty23: ele.selled_qty_23,
          omitQty: this.conditions.legacy_deduction,
          breakRuleQty: this.conditions.viola_qty,
        })
      });
      this.bgjhl = Object.assign([], res.data.bgjhl)
      this.gridTrimOptions.data = res.data.bgjhl || []
      this.gridTrimOptions.data.forEach((ele,index) => {
        ele.total = ele.aloc_total_qty
        for (const key in ele) {
          if (Object.hasOwnProperty.call(ele, key)) {
            if(ele[key] && ele[key].indexOf('-')>-1){
              this.gridTrimOptions.data[index][key] = '-' + ele[key].replace('-', '')
            }
          }
        }
      });
      this.templates.price = res.data?.bgjhl[0]?.price || ''
      // this.gridTrimOptions.data.push(this.templates)
      this.handleTemp()
    },
    saveSaleItem(title ,row){
      console.log(title, row,'090')
      const bottle = this.conditions.chfl ===  '011102'? 2 : 6
      const arr = [1,2,3,4,5,6,7,8,9,10,11,12]
      // this.gridTrimOptions.data = this.bgjhl.concat([{...row}])
      this.gridTrimOptions.data = JSON.parse(JSON.stringify(this.gridTrimOptions.data))
      // 平分数量
      if(title === 'aloc_total_qty'){
        this.gridTrimOptions.data.forEach((ele, index) => {
          if((this.gridTrimOptions.data[index].aloc_total_qty - 0) &&  Math.floor((this.gridTrimOptions.data[index].aloc_total_qty - 0)/12) === ((this.gridTrimOptions.data[index].aloc_total_qty - 0)/12)){
            arr.forEach(item => {
              // this.gridTrimOptions.data[index][item] = (this.gridTrimOptions.data[index].aloc_total_qty - 0)/12
              this.gridTrimOptions.data[index]['plan_qty_'+item] = ((this.gridTrimOptions.data[index].aloc_total_qty - 0)/12)
            });
            let num = (this.gridTrimOptions.data[index].aloc_total_qty - 0) * bottle  * this.gridTrimOptions.data[index].price  /10000
            num =  Math.round((num + Number.EPSILON)*10000) / 10000
            this.gridTrimOptions.data[index].total_price =  num.toFixed(4)
          }
        });
      }else{
        this.gridTrimOptions.data.forEach((item, index) => {
          this.gridTrimOptions.data[index].aloc_total_qty = 0
        })
        // 计算总价
        this.gridTrimOptions.data.forEach((item, index) => {
          arr.forEach(ele => {
            if( this.gridTrimOptions.data[index]['plan_qty_'+ele]){
              this.gridTrimOptions.data[index].aloc_total_qty = ( this.gridTrimOptions.data[index].aloc_total_qty - 0) + ( this.gridTrimOptions.data[index]['plan_qty_'+ele] - 0)
               let num =  this.gridTrimOptions.data[index].aloc_total_qty * bottle  *  this.gridTrimOptions.data[index].price /10000
               num =  Math.round((num + Number.EPSILON)*10000) / 10000
              this.gridTrimOptions.data[index].total_price =  num.toFixed(4)
            }
          });
        });
      }
    },
    // 根据签约号查询详情
    async getSpctById(plan_cntr_no){
      const params = {
        dept_code: this.role.deptCode,
        user_bp: this.role.USER_BP,
        plan_cntr_no,
        mode: 'PD'
      }
      const res = await getSpctById(params)
      if(res.msgtype === "E"){
        return Message.warning(res.message)
      }
      this.gridOptionsFile.data = [...res.data.attachment]
      this.conditions.customer = res.data.head.customer
      this.conditions.cust_name = res.data.head.cust_name
      this.conditions.customer_type = res.data?.head?.customer_type
      this.conditions.chg_plan_cntr_no =  res.data?.head?.plan_cntr_no
      this.conditions.chfl = res.data?.head?.chfl
      this.conditions.pre_aloc_plan_qty = res.data?.head?.pre_aloc_plan_qty
      this.conditions.pre_aloc_min_qty = res.data?.head?.pre_aloc_min_qty || res.data?.head?.signedDown
      this.conditions.pre_aloc_max_qty = res.data?.head?.pre_aloc_max_qty || res.data?.head?.signedUp
      // this.conditions.uname_text = res.data?.head?.uname_text
      this.conditions.plan_type = res.data?.head?.plan_type
      this.saleCenterLists =[{
          zzfld00001h: res.data?.head?.sal_center,
          mc_short: res.data?.head?.sal_center_text,
      }]
      this.conditions.sal_center = res.data?.head?.sal_center
      this.conditions.gjahr = res.data?.head?.gjahr
      this.countYearArea = this.conditions.gjahr + '年营销区域'
      this.countYearChannel = this.conditions.gjahr +'年营销渠道'
      this.countYearPlan = this.conditions.gjahr +'年计划量'
      this.getCenterFz(this.conditions)
      this.gridOptions.data.forEach((ele,index) => {
        for (const key in ele) {
          if (Object.hasOwnProperty.call(ele, key)) {
            const element = ele[key];
            console.log(`output->`,ele,key,ele[key])
            if(ele[key].indexOf('-')>-1){
              this.gridOptions.data[index][key] = '-' + ele[key].replace('-', '')
            }
          }
        }
      });
      this.gridRecordOptions.data = res.data?.history || []
      this.gridOptionsPlanDetail.data = []
      res.data.lssl.length > 0 && res.data.lssl.forEach(ele => {
        this.gridOptionsPlanDetail.data.push({
          planQty21: ele.plan_qty_21,
          planQty22: ele.plan_qty_22,
          planQty23: ele.plan_qty_23,
          billQty21: ele.bill_qty_21,
          billQty22: ele.bill_qty_22,
          billQty23: ele.bill_qty_23,
          deliverQty21: ele.deliver_qty_21,
          deliverQty22: ele.deliver_qty_22,
          deliverQty23: ele.deliver_qty_23,
          selledStock: ele.selled_stock,
          selledQty21: ele.selled_qty_21,
          selledQty22: ele.selled_qty_22,
          selledQty23: ele.selled_qty_23,
          omitQty: this.conditions.legacy_deduction,
          breakRuleQty: this.conditions.viola_qty,
        })
      });
      this.bgjhl = Object.assign([], res.data.bgjhl)
      this.gridTrimOptions.data = res.data.bgjhl || []
      this.gridTrimOptions.data.forEach((ele,index) => {
        ele.total = ele.aloc_total_qty
        for (const key in ele) {
          if (Object.hasOwnProperty.call(ele, key)) {
            if(ele[key] && ele[key].indexOf('-')>-1){
              this.gridTrimOptions.data[index][key] = '-' + ele[key].replace('-', '')
            }
          }
        }
      });
      this.templates.price = res.data?.bgjhl[0]?.price || ''
      // this.gridTrimOptions.data.push(this.templates)
      this.handleTemp()
      this.findContractChannel()
      // this.dialogForm.main_contont = '本次提报1家订单客户的配额计划，参考总量' + this.conditions.pre_aloc_plan_qty + '件，总金额'+this.conditions.pre_aloc_plan_amt+'(万元)，营销大区实际确定签约量共' + this.saveGridOptions[0].aloc_total_qty + '件，总金额' + this.saveGridOptions[0].total_price + '(万元)。'
    },
    changeVal(){
      // if(this.conditions.customer && this.conditions.sal_center && this.conditions.chfl && this.conditions.plan_type){
      //   this.findSaleplanHistory()
      //   this.findContractArea()
      //   this.findContractChannel()
      //   this.findBrandPrice()
      // }
    },
    // 存货分类接口
    async findchflList(){
      const res = await findchflList({customerCode: this.conditions.customer})
      this.chflList = res.data
    },
    // 计划类型
    async findnewPlanTypeList(){
        const res = await findnewPlanTypeList({customerCode: this.conditions.customer})
      this.planTypeList = res.data
    },
    // 历史数据
    async findSaleplanHistory(){
      const params = {
        brand: this.conditions.chfl,
        customerCode: this.conditions.customer,
        planType: this.conditions.plan_type,
        saleCenter: this.conditions.sal_center,
        year: this.conditions.gjahr - 0
      }
      // const params = {
      //   brand: '0122',
      //   customerCode: '0050000215',
      //   planType: this.conditions.plan_type,
      //   saleCenter: this.conditions.sal_center,
      //   year: this.conditions.gjahr - 0
      // }
      const res = await findSaleplanHistory(params)
      this.gridOptionsPlanDetail.data = res.data
      this.conditions.pre_aloc_plan_qty = res.data[0].signedQty
      this.conditions.pre_aloc_min_qty = res.data[0]?.signedDown
      this.conditions.pre_aloc_max_qty = res.data[0]?.signedUp
      this.conditions.viola_qty = res.data[0]?.breakRuleQty
      this.conditions.legacy_deduction = res.data[0]?.omitQty
    },
    // 销售区域
    async findContractArea(){
      const params = {
        brand: this.conditions.chfl,
        customerCode: this.conditions.customer,
        saleCenter: this.conditions.sal_center,
        year: this.conditions.gjahr - 1,
        newPlanType: this.conditions.plan_type,
      }
      const res = await findContractArea(params)
      this.gridOptionArea.data = res.data
    },
    // 销售渠道
    async findContractChannel(){
      const params = {
        brand: this.conditions.chfl,
        customerCode: this.conditions.customer,
        saleCenter: this.conditions.sal_center,
        year: this.conditions.gjahr - 1,
        newPlanType: this.conditions.plan_type,
      }
      const res = await findContractChannel(params)
      this.channelList = res.data || []
    },

    // 生成OA文件附件并上传服务器
    async getSendOAFiles(){
      const params = [{
        ...this.conditions,
        ...this.gridOptionsPlanDetail.data[0],
      }]
      const res = await getSendOAFiles(params)
      this.saveData('SUBMIT_OA', res.data?.fileList)
    },
    async saveData(mode, data = []){
      this.errorList = []
      this.$refs.form.validate(async(val, err) => {
        if (val) {
          const trimOptions = this.gridTrimOptions.data[this.gridTrimOptions.data.length - 1]
          if(trimOptions.total - 0 !== trimOptions.aloc_total_qty - 0){
            this.errorList.push('计划量调整明细的申请计划量不等于月度计划量合计')
            return
          }
          let es_submit = []
          if(mode === 'SUBMIT_OA'){
            es_submit = [{
              sal_center: this.conditions.sal_center,
              plan_type: this.conditions.plan_type,
              approval_no: this.conditions.approval_no,
              ...this.dialogForm,
              file_name: data[0].fileName,
              file_addr: data[0].fileUrl,
            }]
          }
          // 选择渠道
          const qudao = []
          this.channelList.length > 0 && this.channelList.forEach((item) => {
            qudao.push({
              ...item,
              chl_name: item.chlName
            })
          });
          // 区域
          const area = []
          this.gridOptionArea.data.forEach(ele => {
            area.push({
              ...ele,
              city_name: ele.city_name,
              regn_name: ele.regn_name,
              street_name: ele.street_name,
            })

          });
          let lssl = []
          this.gridOptionsPlanDetail.data.length > 0 && this.gridOptionsPlanDetail.data.forEach(ele => {
            lssl.push({
              plan_cntr_no: this.conditions.plan_cntr_no,
              plan_qty_21:ele.planQty21 ,
              plan_qty_22:ele.planQty22 ,
              plan_qty_23:ele.planQty23 ,
              bill_qty_21:ele.billQty21 ,
              bill_qty_22:ele.billQty22 ,
              bill_qty_23:ele.billQty23 ,
              deliver_qty_21:ele.deliverQty21 ,
              deliver_qty_22:ele.deliverQty22 ,
              deliver_qty_23:ele.deliverQty23 ,
              // left_qty_21:ele. ,
              // left_qty_22:ele. ,
              // left_qty_23:ele. ,
              selled_stock:ele.selledStock ,
              selled_qty_21:ele.selledQty21 ,
              selled_qty_22:ele.selledQty22 ,
              selled_qty_23:ele.selledQty23 ,
            })
          });
          const params = {
            mode,
            user_bp: this.role.USER_BP,
            head: this.conditions,
            qudao,
            attachment: this.gridOptionsFile.data,
            area,
            bgjhl: this.bgjhl,
            item: [this.gridTrimOptions.data[this.gridTrimOptions.data.length - 1]],
            ext_sys: '',
            lssl,
            es_submit,
            dept_code: this.role.deptCode,
            assign: this.checkAssign
          }
          const res = await spctChgOrder(params)
          this.errorList = []
          if(res.msgtype === 'S'){
            this.$router.push({
              path: '/wly/qy/sale-plan-edit',
              query: {
                plan_cntr_no: res.data.head.plan_cntr_no,
                order_type: res.data.head.order_type,
                status: res.data.head.status,
              }
            })
          }else{
            this.errorList.push(res.message)
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    async uploadFile(file) {
      // console.log(file);
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')
        const dateTime = new Date().getTime()

        const fileData = {
          filename: file.name,
          mimetype: file.raw.type,
          doc_type: file.raw.type,
          xcontent: strArr,
          filelength: file.size,
          zzfld00002d: _this.role.USER_BP,
          uname_text: _this.role.login_user,
          created_date: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          created_time: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效的数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
    },
     // 下载文件
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    },
    // 控件回车
    async handleEnter(e, type, data) {
      console.log('handleEnter', type, data)
      if (!data) return

      switch (type) {
        case 'customer':
          this.conditions.customer = data.customerCode
          this.conditions.cust_name = data.customerName
          this.conditions.customer_type = data.customerType
          this.saleCenterLists = data.orgList
          this.conditions.sal_center = data.orgList[0].zzfld00001h
          this.conditions.saleCenterTextView = data.orgList[0].mc_short
          this.findnewPlanTypeList()
          this.findchflList()
          break
      }
    },
    openDialog(e){
      e.target.blur()
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        this.conditions.customer = data.customerCode
        this.findchflList()
        this.findnewPlanTypeList()
        this.conditions.cust_name = data.customerName
        this.conditions.customer_type = data.customerType
        this.saleCenterLists = data.orgList
        this.conditions.sal_center = data.orgList[0].zzfld00001h
        this.conditions.saleCenterTextView = data.orgList[0].mc_short
      }
      this.showDialog = false
    },
    saleCenterChange(e){
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.ZZFLD000001Name = checkedData.mc_short
      this.conditions.ZZFLD00003E = checkedData.mc_short_jd
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  /deep/ .el-checkbox{
    .el-checkbox__input {
      display: none
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/qy-manage/salePlanChange.vue